import { gql } from '@apollo/client';

export default gql`
    mutation delete_user_ofline_sessions {
        result: deleteOfflineSessions
    }
`;
